import React, { Fragment } from 'react';
import getQueryString from 'querystring';
import Resources from '../../helpers/resources';
import { showToast } from '../../components/toast/toast-action';
import { getAllLearningJourneys } from './upf-assign-util';
import { getAllAssessments, getAssessments, getAssignments } from './assessment-assign-api';
import { activateModal } from '../modal-manager/modal-manager-actions';
import UnassignModalContent from '../../components/unassign-modal-content';
import { Link } from '../../components/unassign-modal-content/styled';
import { localiseType } from '../../components/assessment-filter/assessment-filter-util';

export const QUERY_STRING_ACQUIRED = 'QUERY_STRING_ACQUIRED';
export const INIT_ASSIGN_DATA_ACQUIRED = 'INIT_ASSIGN_DATA_ACQUIRED';
export const FILTERED_STUDENTS = 'FILTERED_STUDENTS';
export const SELECT_STUDENT = 'SELECT_STUDENT';
export const ERROR_DETECTED = 'ERROR_DETECTED';
export const STUDENT_ASSIGNMENTS = 'STUDENT_ASSIGNMENTS';
export const UPDATE_STUDENT_STATUS = 'UPDATE_STUDENT_STATUS';
export const UPDATE_SORTED_STUDENTS_LIST = 'UPDATE_SORTED_STUDENTS_LIST';
export const PUBLICATIONS_ACQUIRED = 'PUBLICATIONS_ACQUIRED';
export const GENERIC_COURSES_ACQUIRED = 'GENERIC_COURSES_ACQUIRED';
export const SHOW_TOAST = 'SHOW_TOAST';
export const CLASSROOMS_ACQUIRED = 'CLASSROOMS_ACQUIRED';
export const UPDATE_STRANDS = 'UPDATE_STRANDS';
export const UPDATE_SORT_PROPERTIES = 'UPDATE_SORT_PROPERTIES';
export const APPLY_FILTER = 'APPLY_FILTER';
export const UPDATE_SELECTED_COURSE = 'UPDATE_SELECTED_COURSE';
export const SHOW_HIDE_SEARCH_PANEL = 'SHOW_HIDE_SEARCH_PANEL';
export const DISPLAY_MODAL_INFORMATION = 'DISPLAY_MODAL_INFORMATION';
export const HIDE_STANDARD = 'HIDE_STANDARD';
export const ASSIGN_REQUEST = 'ASSIGN_REQUEST';
export const ASSIGN_SUCCESS_REQUEST = 'ASSIGN_SUCCESS_REQUEST';
export const ASSIGN_FAILURE_REQUEST = 'ASSIGN_FAILURE_REQUEST';
export const GRID_CELL_SELECTION = 'GRID_CELL_SELECTION';
export const UNASSIGN_REQUEST = 'UNASSIGN_REQUEST';
export const UNASSIGN_SUCCESS_REQUEST = 'UNASSIGN_SUCCESS_REQUEST';
export const UNASSIGN_FAILURE_REQUEST = 'UNASSIGN_FAILURE_REQUEST';
export const EXPAND_COLLAPSE_REQUEST = 'EXPAND_COLLAPSE_REQUEST';
export const UPDATE_ASSESSMENT_TYPES = 'UPDATE_ASSESSMENT_TYPES';
export const UPDATE_SELECTED_ASSESSMENT_TYPE = 'UPDATE_SELECTED_ASSESSMENT_TYPE';
export const UPDATE_SELECTED_CLASSROOM = 'UPDATE_SELECTED_CLASSROOM';
export const UPDATE_SELECTED_GROUP = 'UPDATE_SELECTED_GROUP';
export const PAUSE_POLLING = 'PAUSE_POLLING';
export const RESUME_POLLING = 'RESUME_POLLING';

const queryString = () => {
  const queryParams = window.location.search;
  const query = queryParams.replace('?', '');
  return getQueryString.parse(query);
};

export const acquireQueryString = () => {
  const { girlId } = queryString();
  return {
    type: QUERY_STRING_ACQUIRED,
    payload: {
      girlId
    }
  };
};

export const studentAssignments = ({
  productId,
  courseId,
  courseVersion,
  assessmentTypeId,
  studentUserProfileIds,
  learningJourneyIds
}) => async (dispatch) => {
  try {
    const response = await getAssignments({
      productId,
      courseId,
      courseVersion,
      assessmentTypeId,
      studentUserProfileIds,
      learningJourneyIds
    });

    if (response.data) {
      dispatch({
        type: STUDENT_ASSIGNMENTS,
        payload: response.data
      });
    } else {
      dispatch({
        type: ERROR_DETECTED,
        payload: response.data
      });
    }
  } catch (err) {
    dispatch({
      type: ERROR_DETECTED,
      payload: err
    });
    throw err;
  }
};

export const updateSortStudents = students => ({
  type: UPDATE_SORTED_STUDENTS_LIST,
  students
});

export const getPublications = i18n => async (dispatch) => {
  let response = null;
  try {
    response = await getAllAssessments();
    if (response && response.data) {
      dispatch({
        type: PUBLICATIONS_ACQUIRED,
        payload: response.data.curriculumCountries
      });
      dispatch({
        type: UPDATE_ASSESSMENT_TYPES,
        assessmentTypes: localiseType(response.data.assessmentTypes, i18n)
      });
    } else {
      dispatch({
        type: SHOW_TOAST,
        isToastVisible: true,
        message: response && response.message,
        messageType: 'warning'
      });
    }
  } catch (err) {
    dispatch({
      type: ERROR_DETECTED,
      payload: err
    });
    throw err;
  }
};

export const getGenericCourses = ({ courseId, courseVersion, i18n }) => async (dispatch) => {
  let response = null;
  try {
    response = await getAssessments({ courseId, courseVersion, i18n });

    if (response && response.data) {
      dispatch({
        type: GENERIC_COURSES_ACQUIRED,
        payload: response.data
      });
    } else {
      dispatch({
        type: SHOW_TOAST,
        isToastVisible: true,
        message: response && response.message
      });
    }
  } catch (err) {
    dispatch({
      type: ERROR_DETECTED,
      payload: err
    });
    throw err;
  }
};

export const getClassrooms = productId => async (dispatch) => {
  let response = null;
  try {
    response = await Resources.classrooms
      .get({})
      .withParams({ productId })
      .send();

    if (response && response.data) {
      dispatch({
        type: CLASSROOMS_ACQUIRED,
        payload: response.data
      });
    } else {
      dispatch({
        type: SHOW_TOAST,
        isToastVisible: true,
        message: response && response.message
      });
    }
  } catch (err) {
    dispatch({
      type: ERROR_DETECTED,
      payload: err
    });
    throw err;
  }
};

export const updateStrand = (actionType, id, checked, searchTerm) => async (dispatch) => {
  dispatch({
    type: UPDATE_STRANDS,
    id,
    checked,
    searchTerm,
    actionType
  });
};

export const applyFilter = () => async (dispatch) => {
  dispatch({
    type: APPLY_FILTER
  });
};

export const showHideSearchPanel = status => async (dispatch) => {
  dispatch({
    type: SHOW_HIDE_SEARCH_PANEL,
    status
  });
};

export const filteredStudents = students => ({
  type: FILTERED_STUDENTS,
  payload: students
});

export const updateSortProps = (direction, sortValue) => ({
  type: UPDATE_SORT_PROPERTIES,
  direction,
  sortValue
});

export const updateSelectedCourse = selectedCourse => ({
  type: UPDATE_SELECTED_COURSE,
  selectedCourse
});

export const displayModalInfo = key => ({
  type: DISPLAY_MODAL_INFORMATION,
  key
});

export const hideStandard = id => ({
  type: HIDE_STANDARD,
  id
});

export const previewAssessment = data => async (dispatch) => {
  try {
    const response = await Resources.previewAssessment
      .post()
      .withBody({
        productId: data.productId,
        assessmentId: data.courseId,
        assessmentVersion: data.courseVersion,
        assessmentType: data.assessmentTypeId,
        duration: data.duration,
        durationType: data.durationType,
        randomize: data.randomize,
        questions: data.questions
      })
      .send();
    return response && response.data;
  } catch (err) {
    dispatch({
      type: ERROR_DETECTED,
      payload: err
    });
    throw err;
  }
};

export const assign = (data, selectedTopics, i18n) => async (dispatch) => {
  try {
    dispatch({ type: ASSIGN_REQUEST });
    const response = await Resources.assign
      .post()
      .withBody({
        productId: data.productId,
        assessmentId: data.courseId,
        assessmentVersion: data.courseVersion,
        assessmentType: data.assessmentTypeId,
        startDateTime: data.scheduleDateTime[0],
        finishDateTime: data.scheduleDateTime[1],
        duration: data.duration,
        durationType: data.durationType,
        randomize: data.randomize,
        assignments: data.studentAssignments
      })
      .send();

    if (response.data) {
      dispatch({
        type: ASSIGN_SUCCESS_REQUEST,
        payload: response.data
      });
      dispatch(
        showToast(
          i18n.t`Student assessments have been assigned successfully`,
          'success'
        )
      );
      dispatch(
        studentAssignments({
          learningJourneyIds: getAllLearningJourneys(selectedTopics),
          studentUserProfileIds: data.filteredStudents.map(student => student.id),
          productId: data.productId,
          courseId: data.courseId,
          assessmentTypeId: data.assessmentTypeId,
          courseVersion: data.courseVersion
        })
      );
    } else {
      const message = i18n.t`Sorry! Your action could not be completed. Please refresh your page and try again.`;
      dispatch({
        type: SHOW_TOAST,
        isToastVisible: true,
        message: (response && response.message) || message,
        messageType: 'warning'
      });
      dispatch({
        type: ASSIGN_FAILURE_REQUEST
      });
    }
  } catch (err) {
    dispatch({
      type: ERROR_DETECTED,
      payload: err
    });
    throw err;
  }
};

export const selectGridCells = (studentId, status, learningJourneyIds) => ({
  type: GRID_CELL_SELECTION,
  studentId,
  status,
  learningJourneyIds
});

const showUnassignModal = i18n => activateModal({
  id: 5,
  className: 'assignModalStyle',
  content: <UnassignModalContent i18n={i18n} />,
  buttons: []
});

export const unAssign = (assignmentIds, data, selectedTopics, i18n) => async (dispatch) => {
  try {
    dispatch({ type: UNASSIGN_REQUEST });
    const response = await Resources.unassign
      .delete()
      .withBody({ assignmentIds })
      .send();

    if (response.data) {
      const { removedAssignmentIds, failedAssignmentIds } = response.data;
      dispatch({
        type: UNASSIGN_SUCCESS_REQUEST,
        payload: response.data
      });
      if (removedAssignmentIds && removedAssignmentIds.length) {
        dispatch(
          showToast(
            <Fragment>
              {
                `${i18n.t`Unassigned`} 
                ${removedAssignmentIds.length} 
                ${removedAssignmentIds.length > 1 ? i18n.t`students` : i18n.t`student`} 
                ${i18n.t`from assessment`}
                `
              }
              {failedAssignmentIds.length ?
                <Fragment> |
                  <Link onClick={() => { dispatch(showUnassignModal(i18n)); }}>
                    {i18n.t`Learn more`}
                  </Link>
                </Fragment> : null
              }
            </Fragment>,
            'success'
          )
        );
      } else if (failedAssignmentIds && failedAssignmentIds.length) {
        dispatch(showUnassignModal(i18n));
      }
      dispatch(
        studentAssignments({
          learningJourneyIds: getAllLearningJourneys(selectedTopics),
          studentUserProfileIds: data.filteredStudents.map(student => student.id),
          productId: data.productId,
          courseId: data.courseId,
          assessmentTypeId: data.assessmentTypeId,
          courseVersion: data.courseVersion
        })
      );
    } else {
      dispatch({
        type: UNASSIGN_FAILURE_REQUEST
      });
    }
  } catch (err) {
    dispatch({
      type: ERROR_DETECTED,
      payload: err
    });
    throw err;
  }
};

export const strandExpandCollapse = strandId => ({
  type: EXPAND_COLLAPSE_REQUEST,
  strandId
});

export const updateSelectedAssessmentType = selectedAssessmentType => ({
  type: UPDATE_SELECTED_ASSESSMENT_TYPE,
  selectedAssessmentType
});

export const updateSelectedClassRoom = selectedClassRoom => ({
  type: UPDATE_SELECTED_CLASSROOM,
  selectedClassRoom
});

export const updateSelectedClassRoomGroup = selectedGroup => ({
  type: UPDATE_SELECTED_GROUP,
  selectedGroup
});

export const pausePolling = () => ({
  type: PAUSE_POLLING
});

export const resumePolling = () => ({
  type: RESUME_POLLING
});
